import React from 'react'
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import transactionComplete from "../../../../../../assets/images/transfercomplete.png"
import { appTheme, showKudzuPlusPrompt } from '../../../../../../helpers/utils/Utils';
import { useSelector } from 'react-redux';
import { selectIsTransferMoneyFeatureEnabled } from '../../../../../../Redux/selectors';


const ScheduledTransfer = ({ onCanelTranfer,isCancelButton,fromAccountType ,showPlusAlertforScheduleTransfer}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const isinSavings = location.pathname.toLocaleLowerCase().includes("savings");
  const cards = useSelector(state => JSON.parse(state.userCards));
  const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
  const isShowKudzuPlusPrompt = showKudzuPlusPrompt(loggedResponse);
  const appThemeData = appTheme(kudzuPlusTrue)
  const isTransferMoneyFeatureEnabled = useSelector(selectIsTransferMoneyFeatureEnabled);
   
  const accountServicesPath = '/AccountServices';
  const manageMoneyPath = '/ManageMoney';
    return (
    <div className=' flex flex-col justify-center items-center w-full'>
      <p className='font-hanken-grotesk text-[var(--modal-text-heading-clr)] text-[16px] font-[400] sm:font-[500] leading-[24px] sm:text-[12px] sm:leading-[18px] md:text-[18px] md:leading-[28px] '>{t("scheduled_fund_transfer_notify_msg")}</p>

      <img src={appThemeData.TransactionComplete} alt="Transaction complete" className={`${kudzuPlusTrue ? 'my-12 mx-auto' :'lg:w-[220px] lg:h-[220px] md:w-[170px] md:h-[170px] w-[129px] h-[129px] sm:m-auto mx-auto'} block`} />
        {
            isTransferMoneyFeatureEnabled ? (
                <div className=' flex flex-col justify-center items-center w-full'>

                    <div className=' flex flex-col justify-center items-center gap-4 w-full'>
                        <Link to={manageMoneyPath} autoFocus className="focus:outline-none inline-block text-center font-hanken-grotesk  font-[500] sm:font-bold leading-[24px]
          text-[15px] sm:text-[15px] md:text-[17px] lg:text-[18px]
          sm:leading-[12px]  md:leading-[16px] bg-[#2965FB]
            text-white border-2 px-2 py-4 border-[#2965FB] w-full">{t("back_to_manage_money")}</Link>                     

                    </div>
                </div>
            ) : (
                    <div className=' flex flex-col justify-center items-center w-full'>

                        <div className=' flex flex-col justify-center items-center gap-4 w-full'>
                            <Link to={accountServicesPath} autoFocus className="focus:outline-none inline-block text-center font-hanken-grotesk  font-[500] sm:font-bold leading-[24px]
          text-[15px] sm:text-[15px] md:text-[17px] lg:text-[18px]
          sm:leading-[12px]  md:leading-[16px] bg-[#2965FB]
            text-white border-2 px-2 py-4 border-[#2965FB] w-full">{t("back_to_account_services")}</Link>
                            {isCancelButton &&
                                <button type="button" className="font-hanken-grotesk text-[15px] sm:text-[15px] md:text-[17px] lg:text-[18px]
 font-[500] sm:font-bold leading-[24px] 
          sm:leading-[12px] md:leading-[16px]  text-[var(--transferBtnTextColor)] cursor-pointer  px-2 py-4  w-full" onClick={() => onCanelTranfer(true)}>{t("cancel_tranfer")}</button>
                            }

                        </div>
                    </div>
            )}
        

    </div>
  )
}

export default ScheduledTransfer